import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { UserProfileApi } from '@/shared/api/users'
import { useAuth } from '@/modules/auth'

/** Another user's name. Pass nothing when you already know the name, such as your own. */
export function useUserDisplayName(userId: string | undefined) {
  const { getAccessToken, isAuthenticated } = useAuth()
  const api = useMemo(() => new UserProfileApi(getAccessToken), [getAccessToken])

  const { data: displayName = null, isLoading } = useQuery({
    queryKey: ['userDisplayName', userId],
    queryFn: () => api.getDisplayName(userId as string),
    enabled: isAuthenticated && !!userId,
  })

  return { displayName, isLoading }
}
